//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    data: {
      required: true,
    },
    cta: {
      required: true,
    },
  },
};
